export default __webpack_public_path__ + "static/media/pp-rebate.281b7cb0.webp";